import { Fragment, useEffect, useRef, useState } from "react";
import SwiperCore, { Pagination, Navigation, Autoplay, EffectFade } from "swiper";
import { useTranslation } from "react-i18next";
import { FinanceSearch } from "./components/financeSearch";
import { FinanceCar } from "./components/financeCar";
import SectionHeading from "../../components/sectionHeading";
import Banner from "../../components/banner";
import { OfferSections } from "../../sections/offersSection";
import Breadcrumb from "../../components/__simple/breadcrumb";
import config from "../../configuration/config";
import axios from "axios";
import Popup from "../../User/popup";
import { Price } from "../../components/__simple/_price";
import { InputField } from "../../components/_input/_input";
import { TextArea } from "../../components/_input/_textArea";
import PhoneDropDown from "../../components/_input/_phoneDropDown";
import { DropDownInput } from "../../components/_input/_dropdown";
import Joi from "joi";
import { formValidate, GetMessages } from "../../utils/validation";
import { includes } from "lodash";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import Skeleton from "react-loading-skeleton";
import * as journifyTrackingCarEvents from "../../services/trackingCarEvents";
import { EmptyState } from "../../components/EmptyState";
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);

export function FinancePage() {
  const { t: trans, i18n } = useTranslation(["heading", "finance", "model", "navbar", "form", "error2", "common", "info", "error"]);
  let lang = i18n.language || "ar";
  const languageDir = "language-" + lang;
  const popRef = useRef();
  const [products, setProducts] = useState([]);
  const [filteredCars, setFilteredCars] = useState(products);
  const [filteredCarsByBrand, setFilteredCarsByBrand] = useState(products);
  const [carBrandFilter, setCarFilter] = useState(null);
  const [activeMenu, setActiveMenu] = useState(1);
  const [banner, setbanner] = useState({});
  const [financeOffers, setFinanceOffers] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [carInfo, setCarInfo] = useState({});
  const [isLoadingVehicles, setLoadingVehicles] = useState(false);
  const [banks, setBanks] = useState([]);
  const [accountTypes, setAccountTypes] = useState([]);
  const [financeSettings, setFinanceSettings] = useState(null);
  const [profitRates, setProfitRates] = useState([]);
  const [isLoadingInfo, setLoadingInfo] = useState(true);
  const [isLoadingSendOrder, setLoadingSendOrder] = useState(false);
  const [selectionBank, setSelectionBank] = useState({});
  const [seoPageInfo, setSeoPageInfo] = useState({});
  const [approximateResult, setApproximateResult] = useState({
    period: "",
    mangFees: null,
    monthPay: null,
    firstPay: null,
    lastPay: null,
    annualRate: "",
    total: null,
  });

  const [requestForm, setRequestForm] = useState({
    custType: null,
    identityNo: "",
    cn: "",
    fullNameAr: "",
    fullNameEn: "",
    phoneNumber: "",
    email: "",
    bankID: "",
    income: "",
    period: "60",
    groupColor: "",
    colorID: "",
    advancedPayment: "",
    monthlyPayment: "",
    note: "",
  });
  const [defaultBank, setDefaultBank] = useState(null);
  const [defaultperiod, setDefaultperiod] = useState(24);
  const [error, setError] = useState({});
  const [identityType, setIdentityType] = useState(null);
  // const [colors, setColors] = useState([]);
  const schema = Joi.object({
    custType: Joi.string().required().messages(GetMessages()),
    identityNo: Joi.string().min(10).required().messages(GetMessages()),
    cn: Joi.string().min(10).required().messages(GetMessages()),
    fullNameAr: Joi.string().required().messages(GetMessages()),
    email: Joi.string()
      .email({ minDomainSegments: 2, tlds: { allow: false } })
      .required()
      .messages(GetMessages()),
    phoneNumber: Joi.string().min(13).required().messages(GetMessages()),
    income: Joi.string().required().messages(GetMessages()),
    period: Joi.number().min(24).max(60).required().messages(GetMessages()),
  });

  useEffect(() => {
    initialBanner();
    initialFinanceoffers();
    // initialProducts();
    // initialBanksData();
    initialCustGroups();
    initalSettings();
    intialProfitRates();
  }, []);

  // useEffect(() => {
  //     setFilteredCars(products);
  // }, [products]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (popRef.current && !popRef.current.contains(event.target) && showPopup === true) {
        resetControls();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopup]);

  let handleRefechData;
  const fn = function (sayHelloFromComp1) {
    handleRefechData = sayHelloFromComp1;
  };

  useEffect(() => {
    if (products && products?.length > 0) {
      handleRefechData();
    }

    // if (activeMenu == 1)
    //     handleFilterByActiveMenu({
    //         maxFinanceAmount: 5000,
    //         maxFinancePeriod: 24,
    //         lastBatch: 40000
    //     }, activeMenu, carBrandFilter);
  }, [products]);
  // filter cars
  function filterCars(carsData, brand) {
    //    //console.log("getCarsByBrand:", carsData);
    //     //console.log("getCarsByBrand:", brand);

    setCarFilter(brand);
    setFilteredCars(carsData);
    let filterData;
    if (brand !== null) {
      switch (brand.toLowerCase()) {
        case trans("finance:brand_toyota").toLowerCase():
          filterData = getCarsByBrand(carsData, trans("finance:brand_toyota").toLowerCase());
          break;

        case trans("finance:brand_lexus").toLowerCase():
          filterData = getCarsByBrand(carsData, trans("finance:brand_lexus").toLowerCase());
          break;
        default:
          filterData = carsData;
      }
    } else {
      filterData = carsData;
    }
    setFilteredCarsByBrand(filterData);
  }

  const initialProductsByBank = async (thisBankID) => {
    setLoadingVehicles(true);
    try {
      setProducts([]);
      axios
        .post(`${config.controllURL}${lang}/api/Pages/${lang === "ar" ? "site_FetchVehiclesByPriceListTypeIDOnlineAr" : "site_FetchVehiclesByPriceListTypeIDOnlineEn"}`, {
          PriceListTypeID: thisBankID,
          // "PriceListTypeID": "Al Rajhi Rental"
        })
        .then((response) => {
          setLoadingVehicles(false);
          const result = response.data;
          console.log("result:", result);
          const customizedResult = result.map((e) => {
            return {
              id: e.OfferID,
              brandID: e.BrandID,
              brandTitle: e.Brand,
              brandImage: e.BrandImage ? "data:image/png;base64," + e.BrandImage : null,
              productID: e.ProductID,
              productImage: e.Image ? config.mainURL + e.Image : null,
              groupID: e.CarGroupID,
              groupTitle: e.Group,
              model: e.Year,
              modelTypeID: e.Type,
              modelTypeTitle: lang === "ar" ? e.GroupEnglish : e.Group,
              colorID: e.ColorID,
              colorGroupID: e.ColorGroupID,
              colorName: lang === "ar" ? e["Color Araboc"] : e["Color English"],
              colorImage: e.ColorImage ? "data:image/png;base64," + e.ColorImage : null,
              price: e.MinPrice,
              showPric: true,
              buyOnline: e.BuyOnline,
              sn: e.SN,
            };
          });

          console.log("customizedResult:", customizedResult);
          setProducts(customizedResult);
        })
        .catch((error) => {
          //////console.log(error);
          setLoadingVehicles(false);
        });
    } catch (error) {
      ////console.log(error);
      setLoadingVehicles(false);
    }
  };

  // It's used to filter the cars by brand
  const getCarsByBrand = (carsData, brand) => {
    //////console.log("getCarsByBrand:", carsData);
    //////console.log("getCarsByBrand:", brand);

    try {
      return carsData?.filter((e) => {
        return e.brandTitle.toLowerCase() === brand;
      });
    } catch (error) {
      return [];
    }
  };

  const handleFilterByBank = (activeBank) => {
    try {
      //console.log("handleFilterByBank:", activeBank);
      const val = { ...requestForm };
      val.bankID = activeBank.GUID;
      setRequestForm(val);
      setSelectionBank(activeBank);
      setDefaultBank(activeBank?.GUID);

      initialProductsByBank(activeBank?.PriceListTypeID);
    } catch (err) {
      //////console.log(err);
      //console.log("err handleFilterByBank:", activeBank);
    }
  };

  const initialBanner = async () => {
    let result = [];

    const response = await axios.request({
      baseURL: config.controllURL,
      url: lang + "/api/Finance/Banner",
      method: "get",
    });

    //////console.log('response.data.banner:', response.data.banner);
    result = response.data.banner;
    setTimeout(setbanner(result), 500);
    return result;
  };

  // to fetch the finance offers
  const initialFinanceoffers = () => {
    axios
      .post(`${config.controllURL}${lang}/api/Pages/SiteFetchOffersFinanceWithSettingBank`, {})
      .then((response) => {
        const descriptionModel = trans("model:description");
        const responseData = response.data.map((item, index) => {
          return {
            key: index,
            startDate: item?.StartDate,
            endDate: item?.EndDate,
            title: item[`Title${descriptionModel}`],
            excerpt: item[`${lang === "ar" ? "excerptAr" : "excerptEn"}`],
            slug: item?.slugAr,
            otherLink: item?.slugEn,
            totalDays: item?.TotalDays,
            image: item.Image,
          };
        });
        setFinanceOffers(responseData);
      })
      .catch((error) => {
        //////console.log('Error in fetching the finance offers', error);
      });
  };

  //It's used to fetch all the customer types
  const initialCustGroups = () => {
    axios
      .post(`${config.controllURL}${lang}/api/Pages/SiteGetCustGroupsCollection`, {})
      .then((response) => {
        setAccountTypes(response.data);
      })
      .catch((err) => {
        //////console.log(err);
      });
  };

  // to handle the specific car order
  const handleOnApplay = (car, selectionBank) => {
    setShowPopup(true);
    setCarInfo({ ...car });
    console.log("car:", car);
    reCountFinanceSettings(car, selectionBank, requestForm?.period);
    // axios.post(
    //     config.baseURL + 'func',
    //     {
    //         "name": "SiteFetchColorsByGroup",
    //         "values": {
    //             "CroupColorID": car.groupColor,
    //             "Type": car.modelType
    //         }
    //     }
    // ).then(response => {
    //     setColors(response.data.map(item => {
    //         return { value: item.ColorID, text: item[`${trans("model:description")}`] }
    //     }));
    // }).catch(err => {

    // });
  };

  // to intialize the finance settings
  const initalSettings = () => {
    axios
      .post(`${config.controllURL}${lang}/api/Pages/SiteFetchActiveBankWithFinanceSettings`, {})
      .then((response) => {
        setFinanceSettings(response.data[0]);
      })
      .catch((err) => {
        //////console.log(err);
      });
  };
  // to intialize the finance profit Rates
  const intialProfitRates = () => {
    axios
      .post(`${config.controllURL}${lang}/api/Pages/SiteFetchProfitRates`, {})
      .then((response) => {
        setProfitRates(response.data);
      })
      .catch((err) => {
        //////console.log(err);
      });
  };

  // to reset controls
  const resetControls = () => {
    setShowPopup(false);
    setCarInfo({});
    setIdentityType(null);
    setError({});
    setApproximateResult({
      period: "",
      mangFees: null,
      monthPay: null,
      firstPay: null,
      lastPay: null,
      annualRate: "",
      total: "",
    });
    setRequestForm({
      ...requestForm,
      custType: null,
      identityNo: "",
      cn: "",
      fullNameAr: "",
      fullNameEn: "",
      phoneNumber: "",
      email: "",
      income: null,
      colorID: "",
      advancedPayment: null,
      lastPayment: null,
      note: "",
    });
  };

  const countFinancCar = async (priceCar, instance) => {
    const { maxFinancePeriod, maxFinanceAmount, lastBatch } = instance;
    var finalAmount = 0;
    // try {
    const firstPay = selectionBank?.AdvancedPaymentRate / 100 ?? 0;
    const lastPay = selectionBank?.AdvancedPaymentRate / 100 ?? 0;
    const managementFees = financeSettings?.ManagementFees ? financeSettings?.ManagementFees / 100 : 0; // الرسوم الادارية
    const financeRate = selectionBank?.FinanceRate / 100 ?? 0; //نسبة الفائدة

    const firstPayPrice = firstPay * parseFloat(priceCar);
    const lastPayPrice = lastPay * parseFloat(priceCar);

    const financeAmount = parseFloat(priceCar) - parseFloat(firstPayPrice);

    var addAmount = financeAmount * financeRate * (maxFinancePeriod / 12);

    if (addAmount && managementFees && managementFees > 0) {
      // الرسوم الادارية
      var managementFeesAmount = financeAmount * managementFees;
      managementFeesAmount = managementFeesAmount + managementFeesAmount * 0.15;
      addAmount = addAmount + managementFeesAmount;
    }

    const mounthBrach = (financeAmount + addAmount - lastPayPrice) / (maxFinancePeriod - 1);

    finalAmount = mounthBrach * (maxFinancePeriod - 1) + lastPayPrice + firstPayPrice;

    // } catch (error) {

    // }

    ////console.log("finalAmount>>>>>>>>>>>>>>>>>>>:", finalAmount);
    return parseFloat(finalAmount);
  };

  const handleFilterByActiveMenu = async (obj, thisActiveMenu, thiscarBrandFilter = carBrandFilter) => {
    //console.log("handleFilterByActiveMenu:", thisActiveMenu);
    //console.log("handleFilterByActiveMenu:", obj);
    //console.log("handleFilterByActiveMenu:", products);
    if (products && products?.length > 0) {
      const instance = { ...obj };
      setLoadingInfo(true);
      setTimeout(() => {
        ////console.log("handleFilterByActiveMenu:", instance);
        let filteredData;
        console.log("activeMenu:", thisActiveMenu);
        console.log("thiscarBrandFilter:", thiscarBrandFilter);
        console.log("products:", products);

        switch (thisActiveMenu) {
          case 1:
            const { maxFinancePeriod, maxFinanceAmount, lastBatch } = instance;

            // setDefaultperiod(maxFinancePeriod);
            //////console.log("instance:", instance);
            const total = (parseFloat(maxFinanceAmount) * maxFinancePeriod - parseFloat(lastBatch)) / (maxFinancePeriod - 1);
            //////console.log("total:", total);
            const finalTotal = parseFloat(total) * (maxFinancePeriod - 1) + parseFloat(lastBatch);
            //////console.log("finalTotal>>>>>>>>>>>>>>>>>>>:", finalTotal);

            // const DatawithFinanc = products?.filter(async car => {
            //     return (car.finalFinaniceTotal = ((parseFloat(await countFinancCar(car.price, instance)))))
            // });

            const DatawithFinanc = products?.filter(async (car) => {
              return (car.finalFinaniceTotal = car.price);
            });
            ////console.log("DatawithFinanc>>>>>>>>>>>>>>>>>>>:", DatawithFinanc);
            setTimeout(() => {
              filteredData = DatawithFinanc?.filter((car) => {
                return finalTotal >= car.finalFinaniceTotal;
              });
              ////console.log("filteredData>>>>>>>>>>>>>>>>>>>:", filteredData);
              filterCars(filteredData, thiscarBrandFilter);
              setLoadingInfo(false);
            }, 100);
            break;
          case 2:
            const { brandID, groupID, subCategoryID } = instance;
            filteredData = products?.filter((car) => {
              return (
                (brandID && brandID.trim().length > 0 ? car.brandID === brandID : 1 === 1) &&
                (groupID && groupID.trim().length > 0 ? car.groupID === groupID : 1 === 1) &&
                (subCategoryID && subCategoryID.trim().length > 0 ? car.modelTypeID === subCategoryID : 1 === 1)
              );
            });

            filterCars(filteredData, thiscarBrandFilter);
            setLoadingInfo(false);
            break;
          case 3:
            const { budget } = instance;
            //////console.log("budget:", budget);
            if (budget) {
              filteredData = products?.filter((car) => {
                return budget >= car.price;
              });
            }

            filterCars(filteredData, thiscarBrandFilter);
            setLoadingInfo(false);
            break;
        }

        //////console.log("filteredData:", filteredData);
      }, 10);
    }
  };
  // to sumbit finance car order
  const handleSubmit = () => {
    try {
      if (!isLoadingSendOrder) {
        //////console.log("handleSubmit:", requestForm);
        setLoadingSendOrder(true);
        const result = formValidate(schema, requestForm) ?? {};
        let unspesificErrors = null;
        let newErrors = {};
        if (identityType === 1) {
          // identity type is (identity card)
          unspesificErrors = ["cn"];
        } else if (identityType === 2) {
          unspesificErrors = ["identityNo"];
        }
        newErrors = unspesificErrors ? removeUnspecificError(result, unspesificErrors) : result;

        ////console.log("newErrors", newErrors);
        setError(newErrors);
        if (Object.keys(newErrors).length === 0) {
          const { LastPaymentRate } = { ...financeSettings };
          if (requestForm.income > 0) {
            axios
              .post(`${config.controllURL}${lang}/api/Pages/AddSiteFinanceOrders`, {
                OfferID: carInfo.offerID,
                ProductID: carInfo.productID,
                ModelYear: carInfo.model,
                CustType: requestForm.custType,
                IdentityNo: requestForm.identityNo,
                CN: requestForm.cn,
                Email: requestForm.email,
                FullNameAr: requestForm.fullNameAr,
                FullNameEn: requestForm.fullNameEn,
                ColorGroup: carInfo.groupColor !== "" && carInfo.groupColor !== undefined && carInfo.groupColor !== null ? carInfo.groupColor : null,
                ColorID: requestForm.colorID !== "" && requestForm.colorID !== null && requestForm.colorID !== undefined ? requestForm.colorID : null,
                BankID: requestForm.bankID !== "" ? requestForm.bankID : null,
                PhoneNumber: requestForm.phoneNumber,
                Income: Number(requestForm.income),
                FirstPayment: requestForm.advancedPayment !== "" && requestForm.advancedPayment !== null && requestForm.advancedPayment !== undefined ? Number(requestForm.advancedPayment) : 0,
                MonthlyAmount: carInfo.price * (LastPaymentRate / 100),
                Period: Math.floor(Number(requestForm.period)) ?? financeSettings.FinancePeriod ?? 1,
                Message: requestForm.note ?? null,
              })
              .then((response) => {
                //-------------------------------
                journifyTrackingCarEvents.trackGenerateLead(approximateResult?.total ?? 0);
                //------------------
                toast.success(trans("common:order-request-success"));
                resetControls();
                setLoadingSendOrder(false);
              })
              .catch((err) => {
                //////console.log(err);
                setLoadingSendOrder(false);
              });
          } else {
            toast.error(trans("error2:not_accept_less_than_0_error"));
            setLoadingSendOrder(false);
          }
        } else {
          //////console.log("newErrors>>:", newErrors);
          setLoadingSendOrder(false);
        }
      }
    } catch (err) {
      //////console.log(err);
      setLoadingSendOrder(false);
    }
  };

  //to select the type of identity
  const handleCustType = (option) => {
    const val = { ...requestForm };
    val.custType = option;
    setRequestForm(val);

    try {
      if (option == "" || option == null || option == "0") {
        setIdentityType(null);
        return;
      }

      // const currentValue = accountTypes.find(item => {
      //     return item.ID == option
      // }) ?? {};

      let value = null;
      if (option === "G1") {
        value = 1;
        val.cn = null;
      } else {
        value = 2;
        val.identityNo = null;
      }

      setRequestForm(val);
      setIdentityType(value);
    } catch (err) {
      //////console.log(err);
    }
  };

  const [selectedFinancePeriod, setSelectedFinancePeriod] = useState(24);
  const [minFirstPayPrice, setMinFirstPayPrice] = useState(0);
  const reCountFinanceSettings = (carInfo, financeSettings, selectedFinancePeriod, currentFirstPayPrice) => {
    try {
      //////console.log('reCountFinanceSettings', financeSettings);
      if (carInfo && financeSettings) {
        let financeData = { ...approximateResult };
        if (carInfo?.price && financeSettings?.ManagementFees >= 0) {
          //selectedFinancePeriod = financeSettings?.MaxFinancePeriod;

          const firstPay = financeSettings?.AdvancedPaymentRate / 100 ?? 0;
          const lastPay = financeSettings?.LastPaymentRate / 100 ?? 0;
          const managementFees = financeSettings?.ManagementFees / 100 ?? 0; // الرسوم الادارية
          const financeRate = financeSettings?.FinanceRate / 100 ?? 0; //نسبة الفائدة

          setMinFirstPayPrice(parseInt(firstPay * carInfo?.price));

          const firstPayPrice = currentFirstPayPrice ? currentFirstPayPrice : firstPay * parseFloat(carInfo?.price);
          const lastPayPrice = lastPay * parseFloat(carInfo?.price);

          const financeAmount = parseFloat(carInfo?.price) - parseFloat(firstPayPrice);

          var addAmount = financeAmount * financeRate * (selectedFinancePeriod / 12);
          var managementFeesAmount = 0;
          if (addAmount && managementFees && managementFees > 0) {
            // الرسوم الادارية
            managementFeesAmount = financeAmount * managementFees;
            managementFeesAmount = managementFeesAmount + managementFeesAmount * 0.15;
            addAmount = addAmount + managementFeesAmount;
          }

          //////console.log('financeAmount', financeAmount);
          //////console.log('addAmount', addAmount);
          //////console.log('lastPayPrice', lastPayPrice);
          //////console.log('financeSettings?.MaxFinancePeriod', selectedFinancePeriod);
          const mounthBrach = (financeAmount + addAmount - lastPayPrice) / (selectedFinancePeriod - 1);

          const finalAmount = mounthBrach * (selectedFinancePeriod - 1) + lastPayPrice + firstPayPrice;

          financeData.period = selectedFinancePeriod;
          financeData.mangFees = managementFeesAmount;
          financeData.total = finalAmount;
          financeData.firstPay = firstPayPrice;
          financeData.lastPay = lastPayPrice;
          financeData.monthPay = mounthBrach;

          //////console.log('financeData', financeData);

          setApproximateResult(financeData);
        }
      }
    } catch (error) {
      ////console.log("error:", error.messages);
    }
  };

  // to remove the unneeded props
  const removeUnspecificError = (errorList, values = []) => {
    let errorResult = {};
    if (values?.length > 0) {
      const lowerValues = values.map((item) => {
        return item.toLowerCase();
      });
      Object.assign(errorResult, errorList);
      if (errorList) {
        for (let index = 0; index < Object.keys(errorList).length; index++) {
          const key = Object.keys(errorList)[index];
          if (includes(lowerValues, key.toLowerCase())) {
            delete errorResult[key];
          } else {
            continue;
          }
        }
      }
    }
    return errorResult;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${config.controllURL}${lang}/api/Pages/SiteFetchSeoPages`, {
          page: "finance",
        });
        if (response.status === 200 && response.data?.[0]) {
          setSeoPageInfo(response.data[0]);
        }
      } catch (e) {
        console.warn("SEO info unavailable:", e?.message);
      }
    };
    fetchData();
  }, []);
  return (
    <Fragment>
      {seoPageInfo && (
        <Helmet>
          <meta charSet="utf-8" />
          {seoPageInfo?.title && <title>{seoPageInfo?.title}</title>}
          {seoPageInfo?.link && <link rel="canonical" href={seoPageInfo?.link} />}
          {seoPageInfo?.MetaDescription && <meta name="description" content={seoPageInfo?.MetaDescription} />}
          {seoPageInfo?.MetaGroups && <meta name="keywords" content={seoPageInfo?.MetaGroups} />}
        </Helmet>
      )}
      <Banner
        subtitle={banner?.subtitle}
        title={banner?.title}
        desc={banner?.excerpt}
        background={banner?.imagePath}
        backOpasity={banner?.backOpasity}
      // btn={hasRedirect ? {
      //     text: trans("info:order-service"),
      //     link: to
      // } : null}
      />
      {/* {banner.map(BN => {

                if (lang === "en") {
                    return (<Banner
                        background={"data:image/png;base64," + BN.image}
                        title={BN.titleEn}
                        subtitle={BN.subTitleEn}
                        desc={BN.excerptEn}
                    />);
                } else {
                    return (<Banner
                        background={"data:image/png;base64," + BN.image}
                        title={BN.titleAr}
                        subtitle={BN.subTitleAr}
                        desc={BN.excerptAr}
                    />);
                }
            })} */}

      <div className="mt-16">
        <Breadcrumb
          className={"container mt-16 "}
          links={[
            {
              name: trans("finance:finance"),
            },
          ]}
        />
        <section className="calc-sec">
          <div className="container">
            <SectionHeading
              title={trans("finance:finance_calculator")}
              subtitle={trans("finance:choose_your_plan")}
              centered={true}
            />
            <FinanceSearch
              onHandleRefechData={fn}
              onSetBanks={(Banks) => {
                //////console.log("Banks>>>>>>>>>>>>>:", Banks);
                setBanks(Banks);
              }}
              selectionBank={selectionBank}
              onBankSelected={(activeBank, thisActiveMenu) => {
                handleFilterByBank(activeBank);
              }}
              onActiveMenu={(index) => {
                setActiveMenu(index);
                // setCarFilter(null);
                filterCars([], null);
              }}
              onSelectedProduct={(value, thisActiveMenu, thiscarBrandFilter) => {
                //console.log("onSelectedProduct>>>>>>>>>>>>>:", value);
                handleFilterByActiveMenu(value, thisActiveMenu, thiscarBrandFilter);
              }}
              onBudgetChange={(value, thisActiveMenu, thiscarBrandFilter) => {
                //console.log("onBudgetChange>>>>>>>>>>>>>:", value);
                handleFilterByActiveMenu(value, thisActiveMenu, thiscarBrandFilter);
              }}
              onQuantitySearchClick={(value, thisActiveMenu, thiscarBrandFilter) => {
                //console.log("onQuantitySearchClick>>>>>>>>>>>>>:", value);
                handleFilterByActiveMenu(value, thisActiveMenu, thiscarBrandFilter);
              }}
              onsetDefaultperiod={(value) => {
                var dp = 24;
                if (value < 36) {
                  dp = 24;
                } else if (value < 48) {
                  dp = 36;
                } else if (value < 60) {
                  dp = 48;
                } else if (value >= 60) {
                  dp = 60;
                }
                //////console.log("MMMMMMMMMMMMMMMMMMMMMMM:>>>", dp);
                const val = { ...requestForm };
                val.period = dp;
                setRequestForm(val);
                setDefaultperiod(dp);
              }}
            />
          </div>
        </section>
      </div>
      <div className={languageDir}>
        <div className="container">
          <div className="mt-24 mb-12">
            <div className="container">
              <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
                <div>
                  <h2 className="text-36 font-black text-vblack mb-2">{trans("finance:available_vehiclaes")}</h2>
                  <p className="text-14 text-vgray font-bold uppercase tracking-widest">{trans("finance:choose_your_dream_car")}</p>
                </div>
                <div className="flex gap-3 overflow-x-auto whitespace-nowrap scroll-hidden pb-2 max-w-full">
                  <button
                    className={`px-8 py-3 rounded-xl font-bold text-14 transition-all flex-shrink-0 ${carBrandFilter === null ? "bg-g text-white shadow-g" : "bg-vwhite text-vblack border border-vsecondary hover:bg-vsecondary"}`}
                    onClick={() => filterCars(filteredCars, null)}
                  >
                    {trans("finance:all")}
                  </button>
                  <button
                    className={`px-8 py-3 rounded-xl font-bold text-14 transition-all flex-shrink-0 ${carBrandFilter?.toLowerCase() === trans("finance:brand_toyota").toLowerCase() ? "bg-g text-white shadow-g" : "bg-vwhite text-vblack border border-vsecondary hover:bg-vsecondary"}`}
                    onClick={() => filterCars(filteredCars, trans("finance:brand_toyota"))}
                  >
                    {trans("finance:brand_toyota")}
                  </button>
                  <button
                    className={`px-8 py-3 rounded-xl font-bold text-14 transition-all flex-shrink-0 ${carBrandFilter?.toLowerCase() === trans("finance:brand_lexus").toLowerCase() ? "bg-g text-white shadow-g" : "bg-vwhite text-vblack border border-vsecondary hover:bg-vsecondary"}`}
                    onClick={() => filterCars(filteredCars, trans("finance:brand_lexus"))}
                  >
                    {trans("finance:brand_lexus")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-32">
          <div className="container">
            {isLoadingVehicles == true ? (
              <div className="vgrid">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                  <div key={i} className="bg-white dark:bg-[#1a1c23] rounded-[2rem] p-6 shadow-sm border border-gray-100 dark:border-white/5">
                    <Skeleton height={280} borderRadius={"1.5rem"} className="mb-6" />
                    <Skeleton width="60%" height={24} className="mb-4" />
                    <div className="flex justify-between items-center">
                      <Skeleton width="40%" height={20} />
                      <Skeleton width="30%" height={40} borderRadius={12} />
                    </div>
                  </div>
                ))}
              </div>
            ) : filteredCarsByBrand?.length > 0 ? (
              <div className="vgrid">
                {filteredCarsByBrand?.map((car, index) => {
                  return (
                    <FinanceCar
                      key={index + "_" + car.sn}
                      onApplay={(car) => handleOnApplay(car, selectionBank)}
                      offerID={car.id}
                      groupColor={car.colorGroupID}
                      modelType={car.modelTypeID}
                      productID={car.productID}
                      brand={car.brandTitle}
                      brandImage={car.brandImage}
                      brandIcon={car.brandIcon}
                      image={car.productImage}
                      name={car.modelTypeTitle}
                      model={car.model}
                      group={car.groupTitle}
                      price={car?.finalFinaniceTotal ? car.finalFinaniceTotal : car?.price}
                      hasOffer={true}
                      brandID={car.brandID}
                      showPric={car?.showPric}
                      colorName={car?.colorName}
                    />
                  );
                })}
              </div>
            ) : (
              <EmptyState message={trans("common:no_results")} />
            )}
          </div>
        </div>

        <OfferSections title={trans("finance:finance_offers")} offersList={financeOffers} />

        <Popup show={showPopup}>
          <div className="finance-popup">
            <div ref={popRef} className="finance-popup-container bg-white dark:bg-vblack flex flex-col md:flex-row relative">
              <button
                className={`modal-close bg-white dark:bg-vblack shadow-sm !m-0 ${lang === 'ar' ? '!left-4 !right-auto' : '!right-4 !left-auto'}`}
                style={{ zIndex: 9999 }}
                onClick={resetControls}
              >✕</button>

              <div className="finance-popup-container-calculator p-8 flex flex-col overflow-y-auto scroll-hidden">
                <div className="calc-card mb-8">
                  <div className="flex flex-col items-center mb-6">
                    <div className="vimg h-48 w-full bg-gray-50 rounded-xl flex items-center justify-center p-4 relative mb-4">
                      <img alt="" className="max-h-full object-contain" src={carInfo.image ? carInfo.image : "/assets/images/car-finance.png"} />
                      <img className="absolute bottom-4 left-4 h-8 opacity-20" src={`/assets/icons/brands/${carInfo?.brandID == 1 ? "toyota-light" : "lexus"}.webp`} alt="" />
                    </div>
                    <h1 className="text-24 font-black mb-2 text-center text-vblack dark:text-white">{carInfo.name}</h1>
                    <div className="flex gap-4 text-14 text-vgray font-bold uppercase tracking-widest">
                      <span>{carInfo?.brand}</span>
                      <span>{carInfo?.model}</span>
                    </div>
                  </div>

                  <div className="space-y-4">
                    {/* Main Month Payment Card */}
                    <div className="calc-out bg-white dark:bg-vblack p-4 rounded-xl shadow-sm border border-gray-100 dark:border-gray-800">
                      <div className="text-xs md:text-12 font-bold text-gray-500 dark:text-gray-300 uppercase tracking-wider mb-2">
                        {trans("finance:monthPayment")}
                      </div>
                      <div className="calc-out-v flex items-baseline gap-2 text-xl md:text-2xl font-black text-gray-900 dark:text-white">
                        <Price price={approximateResult?.monthPay} showZero={true} />
                        <small className="text-xs md:text-sm text-gray-500 dark:text-gray-400 font-medium">
                          / {trans("finance:month")}
                        </small>
                      </div>
                    </div>

                    {/* Other finance details */}
                    <div className="grid grid-cols-2 gap-4 mt-6">
                      {/* Advance Payment */}
                      <div className="bg-gray-50 dark:bg-gray-800/30 p-4 rounded-xl">
                        <div className="text-[10px] md:text-xs font-bold text-gray-400 dark:text-gray-300 uppercase tracking-wider mb-1">
                          {trans("finance:advance_payment")}
                        </div>
                        <div className="text-sm md:text-base font-bold text-gray-900 dark:text-white">
                          <Price price={approximateResult?.firstPay} showZero={true} />
                        </div>
                      </div>

                      {/* Last Payment */}
                      <div className="bg-gray-50 dark:bg-gray-800/30 p-4 rounded-xl">
                        <div className="text-[10px] md:text-xs font-bold text-gray-400 dark:text-gray-300 uppercase tracking-wider mb-1">
                          {trans("finance:lastPayment")}
                        </div>
                        <div className="text-sm md:text-base font-bold text-gray-900 dark:text-white">
                          <Price price={approximateResult?.lastPay} showZero={true} />
                        </div>
                      </div>

                      {/* Period */}
                      <div className="bg-gray-50 dark:bg-gray-800/30 p-4 rounded-xl">
                        <div className="text-[10px] md:text-xs font-bold text-gray-400 dark:text-gray-300 uppercase tracking-wider mb-1">
                          {trans("finance:period")}
                        </div>
                        <div className="text-sm md:text-base font-bold text-gray-900 dark:text-white">
                          {approximateResult?.period} {trans("finance:month")}
                        </div>
                      </div>

                      {/* Final Price */}
                      <div className="bg-gray-50 dark:bg-gray-800/30 p-4 rounded-xl">
                        <div className="text-[10px] md:text-xs font-bold text-gray-400 dark:text-gray-300 uppercase tracking-wider mb-1">
                          {trans("finance:final_price")}
                        </div>
                        <div className="text-sm md:text-base font-bold text-gray-900 dark:text-white">
                          <Price price={approximateResult?.total} showZero={true} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="finance-popup-container-form p-5 flex flex-col nice-gap-2rem nice-flex-space-between flex-1 dark:text-white">
                <div className="flex flex-col">
                  <SectionHeading title={trans("finance:personal_data")} className={"flex flex-col nice-gap-2rem"}>
                    <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-5 ">
                      <DropDownInput
                        title={trans("finance:cust_type") + "*"}
                        errorLabel={error?.custType}
                        defaultOption={requestForm?.custType == null ? { text: trans("finance:cust_type") + "*", value: "0" } : null}
                        extraClasses={"dropdown-Input-module"}
                        options={[
                          ...accountTypes.map((item) => {
                            return { text: item[`${trans("model:description")}`], value: item.CustGroupCollectingID };
                          }),
                        ]}
                        onSelect={handleCustType}
                        selectedValue={requestForm?.custType}
                      />
                    </div>
                    <>
                      {identityType && identityType == 1 ? (
                        <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-5 ">
                          <InputField
                            errorLabel={error?.identityNo}
                            value={requestForm.identityNo}
                            length={10}
                            placeholder={""}
                            extraClasses={"Input-module"}
                            moduleLabel={trans(identityType == 1 ? "form:identity-no" : "finance:cn")}
                            onChangeValue={(e) => {
                              const val = { ...requestForm };
                              val.identityNo = e.target.value;
                              setRequestForm(val);
                            }}
                          />
                        </div>
                      ) : identityType && identityType == 2 ? (
                        <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-5 ">
                          <InputField
                            errorLabel={error?.identityNo}
                            value={requestForm.identityNo}
                            length={20}
                            placeholder={""}
                            extraClasses={"Input-module"}
                            moduleLabel={trans(identityType == 1 ? "form:identity-no" : "finance:cn")}
                            onChangeValue={(e) => {
                              const val = { ...requestForm };
                              val.cn = e.target.value;
                              setRequestForm(val);
                            }}
                          />
                        </div>
                      ) : null}
                    </>

                    <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-5 ">
                      <InputField
                        placeholder={""}
                        errorLabel={error?.fullNameAr}
                        extraClasses={"Input-module"}
                        moduleLabel={trans("form:name") + "*"}
                        value={requestForm.fullNameAr}
                        length={255}
                        onChangeValue={(e) => {
                          const val = { ...requestForm };
                          val.fullNameAr = e.target.value;
                          setRequestForm(val);
                        }}
                      />
                    </div>

                    <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-5 ">
                      <PhoneDropDown
                        errorLabel={error?.phoneNumber}
                        moduleLabel={trans("form:phone") + "*"}
                        extraClasses={"phone-Input-module"}
                        onChangeValue={(countryCode, phoneNumber) => {
                          const val = { ...requestForm };
                          val.phoneNumber = `+${countryCode}${phoneNumber}`;
                          setRequestForm(val);
                        }}
                      />
                    </div>

                    <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-5 ">
                      <InputField
                        type="email"
                        errorLabel={error?.email}
                        placeholder={""}
                        extraClasses={"Input-module"}
                        moduleLabel={trans("form:email") + "*"}
                        value={requestForm.email}
                        onChangeValue={(e) => {
                          const val = { ...requestForm };
                          val.email = e.target.value;
                          setRequestForm(val);
                        }}
                      />
                    </div>
                  </SectionHeading>

                  <SectionHeading title={trans("finance:finance_order_data")} hasRuler={false} className={"flex flex-col nice-gap-2rem"}>
                    <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-5 ">
                      {/* <DropDownInput
                                                    defaultOption={{ text: trans("finance:bank_name"), value: '0' }}
                                                    force={true}
                                                    // defaultOption={defaultBank}
                                                    options={[...banks.map(item => {
                                                        return { ...item,text: lang == "ar" ? (item.nameAr ? item.nameAr : item.DescriptionAr) : (item.nameEn ? item.nameEn : item.DescriptionEn), value: item.GUID }
                                                    })]}

                                                    onSelect={(option) => {
                                                        const val = { ...requestForm };
                                                        val.bankID = option;
                                                        setRequestForm(val);
                                                    }}
                                                    selectedValue={requestForm?.bankID ? requestForm?.bankID : selectionBank.GUID}
                                                /> */}
                      <InputField
                        type="text"
                        disabled={true}
                        placeholder={""}
                        extraClasses={"Input-module"}
                        moduleLabel={trans("finance:bank_name")}
                        errorLabel={error?.bankID}
                        value={lang == "ar" ? (selectionBank.nameAr ? selectionBank.nameAr : selectionBank.DescriptionAr) : selectionBank.nameEn ? selectionBank.nameEn : selectionBank.DescriptionEn}
                        onChangeValue={(e) => { }}
                      />
                    </div>

                    <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-5 ">
                      <InputField
                        min={500}
                        errorLabel={error?.income}
                        type="number"
                        value={requestForm.income}
                        placeholder={""}
                        extraClasses={"Input-module"}
                        moduleLabel={trans("finance:net_income") + "*"}
                        onChangeValue={(e) => {
                          const val = { ...requestForm };
                          val.income = e.target.value;
                          setRequestForm(val);
                        }}
                      />
                    </div>

                    {/* <InputField
                                        min={financeSettings?.FinancePeriod ?? 1}
                                        max={financeSettings?.MaxFinancePeriod ?? 60}
                                        step={financeSettings?.FinancePeriod ?? 1}
                                        errorLabel={error?.period}
                                        type='number'
                                        value={requestForm.period}
                                        title={trans("finance:finance_period") + " (" + trans("finance:byMonth") + " )" + '*'}
                                        onChangeValue={(e) => {
                                            const val = { ...requestForm };
                                            val.period = e.target.value;
                                            setRequestForm(val);
                                            reCountFinanceSettings(carInfo, selectionBank, val.period);
                                        }}
                                    /> */}

                    <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-5 ">
                      <DropDownInput
                        force={true}
                        errorLabel={error?.period}
                        title={trans("finance:finance_period") + " (" + trans("finance:byMonth") + " )" + "*"}
                        extraClasses={"dropdown-Input-module"}
                        // defaultOption={defaultperiod}
                        options={[
                          { text: 24, value: 24 },
                          { text: 36, value: 36 },
                          { text: 48, value: 48 },
                          { text: 60, value: 60 },
                        ]}
                        onSelect={(option) => {
                          const val = { ...requestForm };
                          val.period = option;
                          setRequestForm(val);
                          reCountFinanceSettings(carInfo, selectionBank, val.period);
                        }}
                        selectedValue={requestForm.period}
                      />
                    </div>

                    <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-5 ">
                      <InputField
                        min={minFirstPayPrice}
                        errorLabel={error?.advancedPayment}
                        value={requestForm.advancedPayment}
                        placeholder={""}
                        extraClasses={"Input-module"}
                        moduleLabel={trans("finance:advance_payment")}
                        type="number"
                        onChangeValue={(e) => {
                          // if (e?.target?.value >= minFirstPayPrice) {

                          const val = { ...requestForm };
                          val.advancedPayment = e.target.value;
                          setRequestForm(val);

                          // }
                        }}
                        onLeave={(e) => {
                          if (e?.target?.value >= minFirstPayPrice) {
                            reCountFinanceSettings(carInfo, selectionBank, requestForm.period, e.target.value);
                          } else {
                            const val = { ...requestForm };
                            val.advancedPayment = minFirstPayPrice;
                            setRequestForm(val);
                            reCountFinanceSettings(carInfo, selectionBank, requestForm.period, minFirstPayPrice);
                          }
                        }}
                      />
                    </div>
                    {/* {

                                        colors && <DropDownInput
                                            title={trans("form:color")}
                                            options={[...colors]}
                                            onSelect={(option) => {
                                                const val = { ...requestForm };
                                                val.colorID = option;
                                                setRequestForm(val);
                                            }}
                                        />
                                    } */}

                    <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-5 ">
                      <TextArea
                        placeholder={""}
                        moduleLabel={trans("common:note")}
                        extraClasses={"Textarea-module"}
                        value={requestForm.note}
                        onChangeValue={(e) => {
                          const val = { ...requestForm };
                          val.note = e;
                          setRequestForm(val);
                        }}
                        row={3}
                      />
                    </div>
                  </SectionHeading>
                </div>
                <div className="nice-flex nice-flex-row my-10">
                  {/* <div className="nice-bg-btn bg-black text-white text-14 nice-sm-hidden nice-select-none"
                                        onClick={() => {

                                            // handleCalculate
                                            reCountFinanceSettings(carInfo, selectionBank, requestForm?.period);
                                        }


                                        }
                                    >
                                        {trans("finance:calculate")}
                                    </div> */}
                  <div className="nice-bg-btn bg-primary text-white text-20 nice-select-none" onClick={handleSubmit}>
                    {trans("finance:apply")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Popup>
      </div >
    </Fragment >
  );
}
